import React from 'react';
import HeroBanner from '../components/HeroBanner';
import WelcomeSection from '../components/WelcomeSection';
import Facilities from '../components/Facilities';
import DirectorsDesk from '../components/DirectorsDesk';
import SchoolHighlight from '../components/SchoolHighlights';
import ContactSection from '../components/ContactSection';

const Home = () => {
  return (
    <>
      <HeroBanner />
      <WelcomeSection />
      <Facilities />
      <DirectorsDesk />
      <SchoolHighlight />
      <ContactSection />
    </>
  );
};

export default Home;